import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import reportWebVitals from './reportWebVitals';

import App from './App';
import Home from './pages/home';
import Storage from './pages/storage';
import StorageContacts from './pages/storage/contacts';
import StorageDocuments from './pages/storage/documents';
import StorageInventory from './pages/storage/inventory';
import StorageInventoryReview from './pages/storage/inventory/review';
import StoragePayments from './pages/storage/payments';
import StorageUpdatePayment from './pages/storage/payments/update-payment';
import StorageViewHistory from './pages/storage/payments/view-history';
import StoragePickLists from './pages/storage/pick-lists';
import StoragePickListDetail from './pages/storage/pick-lists/detail';
import Feedback from './pages/feedback/Feedback';
import FeedbackForm from './pages/feedback/FeedbackForm';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

// Get the root element and figure out if we should be rending
// the embedded feedback form or the complete portal based on the
// root element's data-ggview attribute
let isFeedbackEmbed = false;
const rootEl = document.getElementById('portal-app-root');
const root = ReactDOM.createRoot(rootEl);
const targetView = rootEl.getAttribute('data-ggview');
if (targetView && targetView.toLowerCase() === 'feedback') {
  isFeedbackEmbed = true;
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Render just a single route if we are in the embedded feedback form context */}
          {isFeedbackEmbed && (
            <Route path="*" element={<FeedbackForm isEmbedded />} />
          )}

          {!isFeedbackEmbed && (
            <Route path="portal" element={<App />}>
              <Route index element={<Home />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="storage" element={<Storage />}>
                <Route index element={<Navigate to="inventory" replace />} />
                <Route path="inventory">
                  <Route index element={<StorageInventory />} />
                  <Route path="review" element={<StorageInventoryReview />} />
                </Route>
                <Route path="review" element={<StorageInventoryReview />} />
                <Route path="pick-lists">
                  <Route index element={<StoragePickLists />} />
                  <Route path=":id" element={<StoragePickListDetail />} />
                </Route>
                <Route path="payments">
                  <Route index element={<StoragePayments />} />
                  <Route
                    path="update-payment"
                    element={<StorageUpdatePayment />}
                  />
                  <Route path="view-history" element={<StorageViewHistory />} />
                </Route>
                <Route path="documents">
                  <Route index element={<StorageDocuments />} />
                </Route>
                <Route path="contacts">
                  <Route index element={<StorageContacts />} />
                </Route>
              </Route>
            </Route>
          )}
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
